import PostsSection from '@/components/global/posts/section';
import StudiosSection from '@/components/global/studios/section';
import ArtistsSection from '@/components/global/artists/section';
import Intro from '@/components/index/intro';
import Guest from '@/layouts/guest';
import React, {useEffect, useState} from 'react';
import { Container } from 'react-bootstrap';
import axios from "@/app/axios";
import { setCanonical } from '@/app/general';
import Loader from '@/components/global/loader';

type Props = {
  title?: string,
  children?: JSX.Element
};

interface ILatestPosts {
    specials: IPostItem[],
    beats: IPostItem[],
    maquettes: IPostItem[],
    offers: IPostItem[],
    studios: IStudioItem[],
    artists: IArtistItem[]
}

const Index: React.FC<Props> = ({ title, children }) => {
  const [loading, setLoading] = useState(false);

  const [pageInfo, setLatestPosts] = useState<ILatestPosts>({
    specials: [],
    beats: [],
    maquettes: [],
    offers: [],
    studios: [],
    artists: []
  });

  useEffect(() => {
    setLoading(true);
    setCanonical();
    axios.get('api').then((results: { data: ILatestPosts }) => {
      setLatestPosts({...results.data});
    }).finally(() => setLoading(false));
  }, []);

  return (
    <Guest>
      <Intro />
      {loading ? 
            <div className="container-fluid py-5">
              <Loader />
            </div> : (
        <>
          <Container>
            <PostsSection posts={pageInfo.specials} title="آگهی های ویژه" icon="vip" />
            <PostsSection posts={pageInfo.beats} title="بیت" icon="beats" linkToAll="/beats" />
            <PostsSection posts={pageInfo.maquettes} title="تکست و ماکت" icon="maquettes" linkToAll="/maquettes" />
            <PostsSection posts={pageInfo.offers} title="فروش فوق العاده" icon="beats" />
          </Container>
          {/* <SignUpAd /> */}
          <Container>
            <StudiosSection studios={pageInfo.studios} title="استودیوها" icon="studios" />
            <ArtistsSection artists={pageInfo.artists} title="آرتیست ها" icon="artists" />
          </Container>
        </>
      )}
    </Guest>
  );
}

export default Index;
